import { getVersion } from 'helpers/getVersion';

export const logVersion = () => {
  const version = getVersion();

  console.info(`Version ${version}`);
};
